import type { RouteObject } from "react-router-dom";

import { Protected } from "@dzambalaorg/common-pages";

import { ChainLink } from "./chain-link";
import { coinMarketCapRoutes } from "./coin-market-cap/routes";

export const integrationsRoutes: Array<RouteObject> = [
  {
    path: "/chain-link",
    element: <Protected />,
    children: [{ index: true, element: <ChainLink /> }],
  },
  ...coinMarketCapRoutes,
];
